import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import extractText from 'flarum/common/utils/extractText';

/**
 * A source the text actually cites. `label` numbers citations 1..k in order
 * of first appearance, whatever `n` the model used.
 */

const MARKER = /\[\^(\d+)\]/g;

// A marker cut off mid-stream, e.g. `[`, `[^` or `[^1`.
const PARTIAL_MARKER = /\[\^?\d*$/;
export function discussionUrl(source) {
  return app.route('discussion', {
    id: discussionSlug(source)
  });
}
export function postUrl(source) {
  if (!source.number || source.number === 1) return discussionUrl(source);
  return app.route('discussion.near', {
    id: discussionSlug(source),
    near: source.number
  });
}
function discussionSlug(source) {
  return source.slug ? "".concat(source.discussion_id, "-").concat(source.slug) : String(source.discussion_id);
}
export function sourceTitle(source) {
  return source.title || extractText(app.translator.trans('glowingblue-search.forum.ai.untitled_discussion', {
    id: source.discussion_id
  }));
}

/**
 * Render `[^N]` markers as links to their sources. Markers with no matching
 * source are dropped.
 */
export function renderCitedText(text, sources, streaming, href) {
  const byN = new Map(sources.map(source => [Number(source.n), source]));
  const labels = new Map();
  const citations = [];
  const children = [];
  if (streaming) text = text.replace(PARTIAL_MARKER, '');
  let last = 0;
  for (const match of text.matchAll(MARKER)) {
    var _match$index;
    const index = (_match$index = match.index) != null ? _match$index : 0;
    if (index > last) children.push(text.slice(last, index));
    last = index + match[0].length;
    const n = Number(match[1]);
    const source = byN.get(n);
    if (!source) continue;
    let label = labels.get(n);
    if (label === undefined) {
      label = labels.size + 1;
      labels.set(n, label);
      citations.push({
        label,
        source
      });
    }
    children.push(citationLink(label, source, href(source)));
  }
  if (last < text.length) children.push(text.slice(last));
  return {
    children,
    citations
  };
}
export function citationLink(label, source, href) {
  return m(Link, {
    href: href,
    className: "GlowingBlueRag-cite",
    "aria-label": extractText(app.translator.trans('glowingblue-search.forum.ai.citation_label', {
      n: label,
      title: sourceTitle(source)
    }))
  }, label);
}
flarum.reg.add('glowingblue-search', 'forum/ai/citations', { discussionUrl: discussionUrl,postUrl: postUrl,sourceTitle: sourceTitle,renderCitedText: renderCitedText,citationLink: citationLink, });